import { createContext, useContext, useEffect, type ReactNode } from "react";
import {
  useFlowSelection,
  type FlowSelection,
} from "../hooks/useFlowSelection";

const FlowSelectionContext = createContext<FlowSelection | null>(null);

export function FlowSelectionProvider({
  focusedPreOrderId,
  children,
}: Readonly<{ focusedPreOrderId: string | null; children: ReactNode }>) {
  const selection = useFlowSelection();
  const { clear } = selection;
  // Reset on focus-PO change (route :id change) and when leaving focus view.
  useEffect(() => {
    clear();
  }, [focusedPreOrderId, clear]);

  return (
    <FlowSelectionContext.Provider value={selection}>
      {children}
    </FlowSelectionContext.Provider>
  );
}

/** Returns null when outside a FlowSelectionProvider (e.g. list view). */
export function useFlowSelectionOptional(): FlowSelection | null {
  return useContext(FlowSelectionContext);
}

export function useFlowSelectionContext(): FlowSelection {
  const ctx = useContext(FlowSelectionContext);
  if (!ctx) {
    throw new Error(
      "useFlowSelectionContext must be used within FlowSelectionProvider",
    );
  }
  return ctx;
}
